import React from "react";
import styles from "./Intro.module.scss";

// Assets
import GroupImg from "assets/images/png/Group-Image.png";

const Intro = () => {
  return (
    <div className={styles.Intro}>
      <div className={styles.row}>
        <div className={styles.img}>
          <img src={GroupImg} alt="Group" />
        </div>

        <div className={styles.content}>
          <h1>
            Many People <br /> One Heart & One Family
          </h1>
          <p>
            "People rarely succeed unless they have fun in what they are doing."
            At IEEE, we're people-first, meaning we encourage a fun work
            environment that puts others at ease, boosts energy, encourages
            creativity, and undoubtedly increases our team productivity.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Intro;
